module.exports = __webpack_public_path__ + "static/media/JINGLE_START_FAST.28c52d5e.mp3";